export default __webpack_public_path__ + "static/media/drc-logo-header.d8dbac61.png";